var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "export-csv-loader",
      class: { closed: !_vm.isExportsOpen },
      attrs: { "data-testid": "v2-export-file-loader" }
    },
    [
      _c(
        "div",
        {
          staticClass: "export-csv-loader-title",
          on: {
            click: function($event) {
              _vm.isExportsOpen = !_vm.isExportsOpen
            }
          }
        },
        [
          _c("h2", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "EXPORTED_FILES_DETAILS",
                expression: "'EXPORTED_FILES_DETAILS'"
              }
            ]
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-chevron-up",
            class: { "fa-rotate-180": !_vm.isExportsOpen },
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "export-csv-loader-files" },
        _vm._l(_vm.exportJobs, function(job) {
          return _c(
            "div",
            { key: job.id, staticClass: "export-job" },
            [_c("ExportJobItem", { attrs: { job: job } })],
            1
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }